import { FormikProps } from 'formik';
import React from 'react';
import { Button } from '../../Components/Button';
import { FullScreenModalButtonContainer } from '../../Components/FullScreenModal';
import { CreateMedicationListForm, CreateMedicationListStep } from './CreateMedicationListDialog';

export const CreateMedicationListButtons = (props: {
    step: CreateMedicationListStep;
    formProps: FormikProps<CreateMedicationListForm>;
    onClose(): void;
    onContinue(): void;
}) => {
    const formProps = props.formProps;

    if (props.step === CreateMedicationListStep.Error)
        return (
            <Button
                key='Cancel'
                width={168}
                type='button'
                testId={'navigation-control-close'}
                onClick={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onClose();
                }}
            >
                Cancel
            </Button>
        );

    return (
        <FullScreenModalButtonContainer>
            <Button
                key='continue'
                width={168}
                type='button'
                disabled={formProps.isSubmitting}
                testId={'navigation-control-Continue'}
                onClick={props.onContinue}
            >
                Continue
            </Button>
        </FullScreenModalButtonContainer>
    );
};
